import { ProductType } from '@chegg/pricing-sdk';
import { US_COUNTRY_CODE } from '@chegg/utils';
var getIsUpgradeEligible = function getIsUpgradeEligible(_ref) {
  var action = _ref.action,
    productType = _ref.productType,
    products = _ref.products,
    countryCode = _ref.countryCode;
  var canResubscribe = action === 'RESUBSCRIBE';
  var isUsCountryCode = countryCode === US_COUNTRY_CODE;
  var eligibleForCSPUpgrade = isUsCountryCode && canResubscribe && productType === ProductType.CHEGG_STUDY && Array.isArray(products) && products.length > 1;
  return eligibleForCSPUpgrade;
};
export default getIsUpgradeEligible;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/getIsUpgradeEligible.js
// module id = 1369
// module chunks = 11